/* WASA Coffee, round 35 second pass (lane W5): Sort By as a designed list, and small helpers for the filter bar.

   - Sort By: the theme's own <select name="sort_by"> stays in the form (hidden) and keeps sending the same value;
     this script draws a button and a list next to it (role listbox, the current choice marked, arrow keys, Home,
     End, Enter, Space, Escape, Tab, first-letter jump). Choosing an option sets the select and fires the same
     "input" event the theme's filter script already listens for, so sorting works exactly as before.
   - Filter bar: each group shows how many of its values are in use; opening one group closes the others.
   - The theme re-draws the filters after every change; a watcher re-applies both, and keeps keyboard focus on the
     Sort By button when it was there.
   Without this script the theme's own select shows and works. To undo: remove this file's line from
   layout/theme.liquid. */
(function () {
  'use strict';

  var root = document.getElementById('main-collection-filters') || document.querySelector('.facets-container');
  if (!root) return;

  var uid = 0;
  var refocus = false;
  var CARET = '<svg class="wasa-sort__caret" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 1l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.3"/></svg>';
  var CHECK = '<svg class="wasa-sort__check" viewBox="0 0 12 10" aria-hidden="true" focusable="false"><path d="M1 5.2l3.4 3.3L11 1.5" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

  function textOf(el) { return (el && el.textContent || '').replace(/\s+/g, ' ').trim(); }

  function buildSort(select) {
    if (!select || select.getAttribute('data-wasa-sort') === 'on') return;
    var holder = select.closest('.facet-filters__field, .mobile-facets__sort');
    if (!holder) return;
    var old = holder.querySelector('.wasa-sort');
    if (old) old.parentNode.removeChild(old);
    select.setAttribute('data-wasa-sort', 'on');

    var n = ++uid;
    var labelEl = holder.querySelector('label[for="' + select.id + '"]');
    if (labelEl && !labelEl.id) labelEl.id = 'wasaSortLabel' + n;
    var labelId = labelEl ? labelEl.id : '';

    var wrap = document.createElement('div');
    wrap.className = 'wasa-sort';
    wrap.setAttribute('data-wasa-sort-ready', '');

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wasa-sort__button';
    btn.id = 'wasaSortButton' + n;
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    var valueId = 'wasaSortValue' + n;
    btn.innerHTML = '<span class="wasa-sort__value" id="' + valueId + '"></span>' + CARET;
    btn.setAttribute('aria-labelledby', (labelId ? labelId + ' ' : '') + valueId);

    var list = document.createElement('ul');
    list.className = 'wasa-sort__list';
    list.id = 'wasaSortList' + n;
    list.setAttribute('role', 'listbox');
    list.setAttribute('tabindex', '-1');
    if (labelId) list.setAttribute('aria-labelledby', labelId);
    list.hidden = true;
    btn.setAttribute('aria-controls', list.id);

    var options = Array.prototype.map.call(select.options, function (o, i) {
      var li = document.createElement('li');
      li.className = 'wasa-sort__option';
      li.id = list.id + '-o' + i;
      li.setAttribute('role', 'option');
      li.setAttribute('data-value', o.value);
      li.innerHTML = '<span></span>' + CHECK;          /* static markup only; the option's words go in as text */
      li.firstChild.textContent = textOf(o);
      list.appendChild(li);
      return li;
    });

    var active = 0;
    function sync() {
      var idx = Math.max(0, select.selectedIndex);
      options.forEach(function (li, i) { li.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
      document.getElementById(valueId).textContent = textOf(select.options[idx]);
    }
    function setActive(i) {
      active = Math.max(0, Math.min(options.length - 1, i));
      options.forEach(function (li, k) { li.classList.toggle('is-active', k === active); });
      list.setAttribute('aria-activedescendant', options[active].id);
      var o = options[active];
      if (o.offsetTop < list.scrollTop) list.scrollTop = o.offsetTop;
      else if (o.offsetTop + o.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = o.offsetTop + o.offsetHeight - list.clientHeight;
    }
    function open() {
      if (!list.hidden) return;
      list.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      setActive(Math.max(0, select.selectedIndex));
      list.focus({ preventScroll: true });
      document.addEventListener('pointerdown', outside, true);
    }
    function close(focusButton) {
      if (list.hidden) return;
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      list.removeAttribute('aria-activedescendant');
      document.removeEventListener('pointerdown', outside, true);
      if (focusButton) btn.focus({ preventScroll: true });
    }
    function outside(e) { if (!wrap.contains(e.target)) close(false); }
    function choose(i) {
      var li = options[i];
      var changed = select.selectedIndex !== i;
      close(true);
      if (!changed) return;
      select.selectedIndex = i;
      sync();
      refocus = document.activeElement === btn;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      if (li) li.blur && li.blur();
    }

    btn.addEventListener('click', function () { if (list.hidden) open(); else close(true); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open();
        if (e.key === 'ArrowUp') setActive(options.length - 1);
      }
    });
    list.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (k === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (k === 'Home') { e.preventDefault(); setActive(0); }
      else if (k === 'End') { e.preventDefault(); setActive(options.length - 1); }
      else if (k === 'Enter' || k === ' ') { e.preventDefault(); choose(active); }
      else if (k === 'Escape') { e.preventDefault(); e.stopPropagation(); close(true); }
      else if (k === 'Tab') { close(false); }
      else if (k.length === 1 && /\S/.test(k)) {
        var c = k.toLowerCase();
        for (var s = 1; s <= options.length; s++) {
          var j = (active + s) % options.length;
          if (textOf(options[j]).toLowerCase().charAt(0) === c) { setActive(j); break; }
        }
      }
    });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('.wasa-sort__option');
      if (li) choose(options.indexOf(li));
    });
    list.addEventListener('mousemove', function (e) {
      var li = e.target.closest('.wasa-sort__option');
      if (li && options.indexOf(li) !== active) setActive(options.indexOf(li));
    });

    wrap.appendChild(btn);
    wrap.appendChild(list);
    var sel = select.closest('.select');
    (sel || select).insertAdjacentElement('beforebegin', wrap);
    sync();
    if (refocus && select.id === 'SortBy') { refocus = false; btn.focus({ preventScroll: true }); }
  }

  /* Each filter group shows how many of its values are in use (the price group counts as one when set). */
  function counts() {
    var groups = root.querySelectorAll('#FacetsWrapperDesktop details.facets__disclosure');
    Array.prototype.forEach.call(groups, function (d) {
      var line = d.querySelector('.facets__summary-line');
      if (!line) return;
      var n = d.querySelectorAll('.facets__list:not(.no-js-list) input[type="checkbox"]:checked').length;
      var price = d.querySelectorAll('.facets__price input');
      if (price.length && Array.prototype.some.call(price, function (i) { return i.value !== ''; })) n += 1;
      if (n > 0) line.setAttribute('data-wasa-count', String(n));
      else line.removeAttribute('data-wasa-count');
    });
  }

  /* Opening one group closes the others. */
  root.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.matches || !d.matches('#FacetsWrapperDesktop details.facets__disclosure') || !d.open) return;
    Array.prototype.forEach.call(root.querySelectorAll('#FacetsWrapperDesktop details.facets__disclosure[open]'), function (o) {
      if (o !== d) o.removeAttribute('open');
    });
  }, true);

  function apply() {
    Array.prototype.forEach.call(document.querySelectorAll('#SortBy, #SortBy-mobile'), buildSort);
    counts();
  }

  var queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; apply(); });
  }

  apply();
  root.addEventListener('change', queue);
  root.addEventListener('input', function () { window.setTimeout(counts, 0); });
  if ('MutationObserver' in window) {
    new MutationObserver(queue).observe(root, { childList: true, subtree: true });
  }
}());
